module.exports = __webpack_public_path__ + "media/images/lb/036-92151adc4dd070a070d027efbea134ed.svg";